import { ReactNode } from 'react'

import type { ExtendedCustomFieldSection } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { CustomFieldProps } from '@new/__global/components/CustomField/_types'

// This is similar to the concept of a controlled vs uncontrolled component in React.
// If we are passing the viewMode prop, the parent is responsible for updating it so
// we also require the onViewModeClick.
// Otherwise the component takes care of it by itself.
type ControlledOrUncontrolled =
  | {
      viewMode: IFieldsViewMode
      onViewModeClick?: (viewMode: IFieldsViewMode) => void
    }
  | {
      viewMode?: never
      onViewModeClick?: never
    }

export interface CustomFieldSubSectionsProps {
  customFieldIdsToDisplay: string[]
  subSectionTitle: string
}

export type ICustomFieldSection<ExternalFields> = {
  section: ExtendedCustomFieldSection
  customFields: Array<CustomFieldProps>
  enableVerifyMode?: boolean
  saveCustomFieldsMethod: any
  isSavingCustomFieldsPending: boolean
  onGoBack?: VoidFunction
  hideViewModeControls?: boolean
  hideSectionName?: boolean
  customSectionTitle?: string
  getValuesMethod?: any
  homeId?: string
  sectionBeforeCustomFields?: ReactNode
  externalFieldsDefaultValue?: any
  saveExternalFields?: (values?: ExternalFields) => void
  isSavingExternalFieldsPending?: boolean
  hiddenFieldsIdOnEdit?: string[]
  subSections?: CustomFieldSubSectionsProps[]
} & ControlledOrUncontrolled

export enum IFieldsViewMode {
  read = 'read',
  write = 'write',
  verify = 'verify',
}

export interface IViewModeContainer {
  isMobile?: boolean
  center?: boolean
}

export interface CustomFieldProjectionView extends CustomFieldProps {
  isVerified?: boolean
}

export type FormInputs<ExternalFields> = {
  customFields: CustomFieldProjectionView[]
  // defaultCustomFields is used to display read only
  defaultCustomFields: CustomFieldProjectionView[]
  homeId?: string
  externalFields?: ExternalFields
}
